'use client';

export { default } from './ThemeProvider';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/ThemeProvider/index.js
// module id = 738
// module chunks = 22